export const LEAVETYPELIST = "leaveTypelist";
export const LEAVETYPELIST_SUCCESSFULL = "leaveTypelist_successfull";
export const LEAVETYPESLIST = "leaveTypeslist";
export const LEAVETYPESLIST_SUCCESSFULL = "leaveTypeslist_successfull";
export const CREATE_LEAVE_TYPE = "create_leave_type";
export const CREATE_LEAVE_TYPE_SUCCESSFULL = "create_leave_type_successfull";
export const UPDATE_LEAVE_TYPE = "update_leave_type";
export const UPDATE_LEAVE_TYPE_SUCCESSFULL = "update_leave_type_successfull";
export const API_ERRORS = 'api_failed';